import React, { useState, useEffect } from 'react';
import { auth, db, storage } from '../../utils/firebase';
import { doc, updateDoc, arrayUnion, arrayRemove, getDoc, setDoc } from 'firebase/firestore';
import { getDownloadURL, ref } from 'firebase/storage';
import HoverCard from './HoverCard.js';
import './RecreationalActivities.css';

const RecreationalActivities = () => {
  const [user, setUser] = useState(null);
  const [favorites, setFavorites] = useState({});
  const [strikeGymImage, setStrikeGymImage] = useState(null); 
  const [sensyongsMuseumImage, setsensyongsMuseumImage] = useState(null); 
  const [bacoorEcoparkImage, setbacoorEcoparkImage] = useState(null); 

  useEffect(() => {

    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      setUser(currentUser);
      if (currentUser) {
        fetchFavorites(currentUser.uid);
      }
    });

   
    fetchImage('things/strikegymnasium.jpg', setStrikeGymImage);
    fetchImage('things/senyongsmuseum.jpg', setsensyongsMuseumImage);
    fetchImage('things/bacoorecopark.jpg', setbacoorEcoparkImage);

    return unsubscribe;
  }, []);

  const fetchFavorites = async (userId) => {
    const userDocRef = doc(db, 'Users', userId);
    const userDoc = await getDoc(userDocRef);

    if (userDoc.exists()) {
      setFavorites(userDoc.data().favorites || {});
    } else {
      await setDoc(userDocRef, { favorites: {} });
      setFavorites({});
    }
  };

  const fetchImage = async (path, setImageCallback) => {
    try {
      const imageRef = ref(storage, path);
      const url = await getDownloadURL(imageRef);
      setImageCallback(url);
    } catch (error) {
      console.error('Error fetching image:', error);
    }
  };

  const toggleFavorite = async (event, itemTitle) => {
    event.stopPropagation(); 
    if (!user) return;

    const userDocRef = doc(db, 'Users', user.uid);
    const updatedFavorites = { ...favorites };

    const isFavorited = updatedFavorites['Recreational Activities']?.includes(itemTitle);

    if (isFavorited) {
      updatedFavorites['Recreational Activities'] = updatedFavorites['Recreational Activities'].filter(
        (name) => name !== itemTitle
      );
      await updateDoc(userDocRef, { [`favorites.Recreational Activities`]: arrayRemove(itemTitle) });
    } else {
      updatedFavorites['Recreational Activities'] = [
        ...(updatedFavorites['Recreational Activities'] || []),
        itemTitle,
      ];
      await updateDoc(userDocRef, { [`favorites.Recreational Activities`]: arrayUnion(itemTitle) });
    }

    setFavorites(updatedFavorites);
  };

  return (
    <div className="cultural-experiences">
      <h1 className="main-title">Recreational Activities</h1>
      <p className="description">
        Enjoy a range of recreational activities in Bacoor, from gymnasiums to exploring local museums.
      </p>
      <div className="card-container">
        <div className="hover-card-wrapper position-relative">
          <HoverCard
            title="Strike Gymnasium"
            imageUrl={strikeGymImage || 'placeholder-image.jpg'} 
            linkTo="/strikegym"
          />
          {user && (
            <button
              className={`btn btn-light position-absolute top-0 end-0 m-2 p-1 rounded-circle shadow ${
                favorites['Recreational Activities']?.includes('Strike Gymnasium')
                  ? 'text-danger'
                  : ''
              }`}
              onClick={(event) =>
                toggleFavorite(event, 'Strike Gymnasium')
              }
            >
              <i
                className={`bi bi-heart${
                  favorites['Recreational Activities']?.includes('Strike Gymnasium')
                    ? '-fill'
                    : ''
                }`}
              ></i>
            </button>
          )}
        </div>

        <div className="hover-card-wrapper position-relative">
          <HoverCard
            title="Senyong's Museum"
            imageUrl={sensyongsMuseumImage || 'placeholder-image.jpg'} 
            linkTo="/senyongsmuseum"
          />
          {user && (
            <button
              className={`btn btn-light position-absolute top-0 end-0 m-2 p-1 rounded-circle shadow ${
                favorites['Recreational Activities']?.includes("Senyong's Museum")
                  ? 'text-danger'
                  : ''
              }`}
              onClick={(event) =>
                toggleFavorite(event, "Senyong's Museum")
              }
            >
              <i
                className={`bi bi-heart${
                  favorites['Recreational Activities']?.includes("Senyong's Museum")
                    ? '-fill'
                    : ''
                }`}
              ></i>
            </button>
          )}
        </div>

        <div className="hover-card-wrapper position-relative">
          <HoverCard
            title="Bacoor Eco-Park"
            imageUrl={bacoorEcoparkImage || 'placeholder-image.jpg'} 
            linkTo="/bacoorpark"
          />
          {user && (
            <button
              className={`btn btn-light position-absolute top-0 end-0 m-2 p-1 rounded-circle shadow ${
                favorites['Recreational Activities']?.includes("Bacoor Eco-Park")
                  ? 'text-danger'
                  : ''
              }`}
              onClick={(event) =>
                toggleFavorite(event, "Bacoor Eco-Park")
              }
            >
              <i
                className={`bi bi-heart${
                  favorites['Recreational Activities']?.includes("Bacoor Eco-Park")
                    ? '-fill'
                    : ''
                }`}
              ></i>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default RecreationalActivities;
